<script>
  // Card-grid view for an entity (image-heavy sets: media, moments, user icons).
  // Uses the entity's grid.show slots. The PRIMARY column is the card title; any
  // media_thumb/avatar renderer becomes the card's visual; remaining columns render
  // as compact label/value rows.
  import Button from '../ui/button.svelte'
  import EmptyState from '../empty_state.svelte'
  import EntitySlot from './entity_slot.svelte'
  import { columnsForGrid, headerLabel, SLOTS } from '../../lib/entities/slots.js'

  let { config, rows = [], onDelete = null, onToggle = null, emptyMessage = null, actions } = $props()

  const cols = $derived(columnsForGrid(config))
  // A column flagged `cardMedia` wins over the first media_thumb/avatar column.
  const mediaCol = $derived(cols.find((c) => c.cardMedia) ?? cols.find((c) => c.renderer === 'media_thumb' || c.renderer === 'avatar'))
  const primaryCol = $derived(cols.find((c) => c.slot === SLOTS.PRIMARY))
  const restCols = $derived(cols.filter((c) => c !== mediaCol && c !== primaryCol))
  const GRID_COLS = { 2: 'sm:grid-cols-2', 3: 'sm:grid-cols-2 lg:grid-cols-3', 4: 'sm:grid-cols-2 lg:grid-cols-4', 6: 'sm:grid-cols-3 lg:grid-cols-6' }
  const gridCols = $derived(GRID_COLS[config.grid?.columns] ?? GRID_COLS[3])
  const showActions = $derived(!!(actions || onDelete || rows.some((row) => row.edit_url)))
</script>

{#if rows.length === 0}
  <EmptyState icon={config.empty?.icon ?? config.icon} title={emptyMessage ?? config.empty?.message ?? 'No records found.'} />
{:else}
  <div class="grid grid-cols-1 gap-4 {gridCols}">
    {#each rows as row (row.id)}
      <div class="card bg-base-100 border border-base-300">
        {#if mediaCol}
          <figure class="bg-base-200 aspect-square overflow-hidden">
            <EntitySlot {row} column={{ ...mediaCol, fill: true }} />
          </figure>
        {/if}
        <div class="card-body p-4 gap-2">
          {#if primaryCol}
            <div class="font-medium truncate"><EntitySlot {row} column={primaryCol} /></div>
          {/if}
          {#each restCols as col (col.field)}
            <div class="flex items-center justify-between gap-2 text-sm">
              {#if headerLabel(col)}<span class="text-base-content/50">{headerLabel(col)}</span>{/if}
              <span class="text-right"><EntitySlot {row} column={col} {onToggle} /></span>
            </div>
          {/each}
          {#if showActions}
            <div class="card-actions justify-end mt-1">
              {#if actions}
                {@render actions(row)}
              {:else}
                {#if row.edit_url}<Button variant="ghost" size="xs" square icon="edit" aria-label="Edit" href={row.edit_url} />{/if}
                {#if onDelete}<Button variant="ghost" size="xs" square icon="delete" aria-label={config.deleteLabel ?? 'Delete'} title={config.deleteLabel ?? 'Delete'} class="text-error" onclick={() => onDelete(row)} />{/if}
              {/if}
            </div>
          {/if}
        </div>
      </div>
    {/each}
  </div>
{/if}
